<template>
    <div class="buildPopup" @click="showBuild">
        <div class="build" >
            <div class="buildName">{{name}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props:['name'],
    data(){
        return {
            se:false
        }
    },
    computed:{
        select(){
            console.log(this.flag);
            return this.flag
        }
    },
    mounted(){
        
        
    },
    methods:{
        showBuild(){
            if(this.onOff){
                this.onOff()
            }
        }
    }
}
</script>

<style lang="less" scoped>
.buildPopup{
    position: fixed;
    bottom: 30vh;
    left:30vw;
    z-index: 1;
    width: 170px;
    height: 80px;
    background-image: url(../../../assets/img/buildLogo.png);
    background-size: 100% 100%;
    cursor: pointer;
    margin-left: -30px;

    .build{
        height: 80px;
        .buildName{
            color: #fff;
            font-size: 16px;
            font-family: seSource Han Sans CNrif;
            text-align: center;
            position: relative;
            top: 20px;
        }
    }
}

</style>